import en from './en/index';
import pl from './pl/index';
import ru from './ru/index';
import uk from './uk/index';

export const messages = {
  en,
  pl,
  ru,
  uk,
};
